import React from 'react';
import styled from 'styled-components';

const ItemButtonStyle = styled.div`
	padding: 8px;
	padding-bottom: 4px;
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
	:hover {
		background-color: white;
	}
`;

interface ItemButtonProps {
	onClick: () => void;
	IconProp: React.ReactNode;
}

export const ItemButton = ({ IconProp, onClick }: ItemButtonProps) => {
	return (
		<ItemButtonStyle onMouseDown={(e) => e.stopPropagation()} onClick={onClick}>
			{IconProp}
		</ItemButtonStyle>
	);
};
